import React, { useContext, useState } from 'react'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material'
import PushPinIcon from '@mui/icons-material/PushPin'
import EventIcon from '@mui/icons-material/Event'
import AddCommentIcon from '@mui/icons-material/AddComment'
import { Hub } from '@mui/icons-material'
import LogsComponent from '../../../components/Logs/LogsComponent'
import { SiteModeContext } from '../../../components/mainFrame/MainFrame'

const CommandLogRow = ({ log }) => {
  const theme = useTheme()
  const [pinned, setPinned] = useState(!!log?.pinned)
  const [openComment, setOpenComment] = useState(false)
  const navigate = useNavigate()
  const { setSiteMode, setSelectedControlRoom } = useContext(SiteModeContext)

  const authorName =
    `${log?.author?.firstName || ''} ${log?.author?.lastName || ''}`.trim()

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
          transform: 'translateY(-1px)',
        },
      }}
    >
      <Stack spacing={1.5}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'flex-start' }}
          gap={1.5}
        >
          <Stack direction="row" gap={1.5} alignItems="flex-start" flex={1}>
            <Avatar
              src={log?.author?.photograph}
              sx={{
                width: 32,
                height: 32,
                fontSize: '0.9rem',
              }}
            >
              {authorName?.[0]}
            </Avatar>

            <Box flex={1}>
              <Stack
                direction="row"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: theme.palette.anBlue.main,
                    lineHeight: 1.2,
                  }}
                >
                  {authorName || 'Unknown User'}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ color: theme.palette.text.secondary }}
                >
                  {moment(log.createdAt).fromNow()}
                </Typography>
                {/* TODO
                {pinned && (
                  <Chip
                    size="small"
                    label="Pinned"
                    sx={{
                      height: 22,
                      backgroundColor: theme.palette.anMuted.main,
                      color: theme.palette.text.primary,
                    }}
                  />
                )} */}
              </Stack>

              <Typography
                sx={{
                  mt: 1,
                  color: theme.palette.text.primary,
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {log?.log ?? log?.information ?? ''}
              </Typography>
            </Box>
          </Stack>

          <Stack
            alignItems={{ xs: 'flex-start', md: 'flex-end' }}
            spacing={1}
            sx={{ minWidth: { md: 180 } }}
          >
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.secondary }}
            >
              {moment(log.createdAt).format('DD/MM/YYYY HH:mm')}
            </Typography>

            {/* <Stack direction="row" spacing={0.5}> */}
            {/* <Tooltip title={pinned ? 'Unpin' : 'Pin'}>
                <IconButton
                  size="small"
                  onClick={() => setPinned((prev) => !prev)}
                  sx={{
                    color: pinned
                      ? theme.palette.contrast.main
                      : theme.palette.text.disabled,
                  }}
                >
                  <PushPinIcon fontSize="small" />
                </IconButton>
              </Tooltip> */}

            {/* <Tooltip title="Comments">
                <IconButton
                  size="small"
                  onClick={() => setOpenComment((prev) => !prev)}
                  sx={{
                    color: openComment
                      ? theme.palette.anPurple.main
                      : theme.palette.text.disabled,
                  }}
                >
                  <AddCommentIcon fontSize="small" />
                </IconButton>
              </Tooltip> */}
            {/* </Stack> */}
          </Stack>
        </Stack>

        {(log?.event || log?.controlRoom) && (
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {log?.event && (
              <Button
                size="small"
                variant="outlined"
                color="info"
                onClick={() => navigate(`/events/${log.event._id}`)}
                startIcon={<EventIcon />}
              >
                {log?.event?.title ?? 'View Event'}
              </Button>
            )}

            {log?.controlRoom && (
              <Button
                size="small"
                variant="outlined"
                color="anPurple"
                onClick={() => {
                  setSelectedControlRoom(log.controlRoom)
                  setSiteMode('eventControl')
                }}
                startIcon={<Hub />}
              >
                View Control Room
              </Button>
            )}
          </Stack>
        )}

        <Box ml={{ xs: 0, sm: 5.5 }}>
          <LogsComponent
            targetType="commandLog"
            targetId={log._id}
            hideTitle
            title="Comment"
            hideIfEmpty
            allowCreateLog
            openComment={openComment}
            setOpenComment={setOpenComment}
            disableFiltering
            hideDivider
          />
        </Box>
      </Stack>
    </Paper>
  )
}

export default CommandLogRow
